import {fromUtcTimeFormat} from "../../../shared/utils/dayjsUtil";

const parseLogData = (logString, record) => {
    if (!record.parsedLogData) {
        try {
            record.parsedLogData = JSON.parse(logString);
        } catch (error) {
            console.error('logString 파싱 오류:', error);
            record.parsedLogData = {};
        }
    }
    return record.parsedLogData;
};

// 22: 프로필 이미지, 23: 프로필 테두리
export const PROFILE_ITEM_TYPE = {IMAGE: 22, FRAME: 23};

const LOG_TYPE_LABEL = {
    gain_Profil: '프로필 이미지 획득',
    gain_Frame: '프로필 테두리 획득',
};

const makeNameMap = (rows) => new Map((rows || []).map(row => [row.index, row.name]));

export const getProfileLogColumns = (profileData) => {
    const nameMaps = {
        [PROFILE_ITEM_TYPE.IMAGE]: makeNameMap(profileData?.profileImg),
        [PROFILE_ITEM_TYPE.FRAME]: makeNameMap(profileData?.profileFrame),
    };

    return [
        {
            title: '로그 타입',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {logType} = parseLogData(logString, record);
                return LOG_TYPE_LABEL[logType] ? `${LOG_TYPE_LABEL[logType]}(${logType})` : logType;
            },
        },
        {
            title: '아이템 인덱스',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).itemInfo?.ItemIndex,
        },
        {
            title: '아이템 이름',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {ItemType, ItemIndex} = parseLogData(logString, record).itemInfo || {};
                return nameMaps[ItemType]?.get(ItemIndex) ?? '';
            },
        },
        {
            title: '트리거 시간',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {triggerTime} = parseLogData(logString, record);
                return triggerTime ? fromUtcTimeFormat(triggerTime) : '';
            },
        },
    ];
};
